<ng-container *transloco="let t; read: 'service-command-editor-auto-accept-call'">
  <p-messages severity="info">
    <ng-template pTemplate>
      <p class="wrap">{{ t('description') }}</p>
    </ng-template>
  </p-messages>
</ng-container>
